import React, { useRef, useState, useEffect } from "react";
import { observer } from "mobx-react";
import ibsStore from "./Stores/IbsSurveyStore";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { default as MaterialTable, TableFilterList } from "mui-datatables";
import store from "./Stores/IbsSurveyStore";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { formatAMPM } from "../helpers";
import { changeSurveyCleanerCtrl, changeSurveyCtrl, changeSurveyStatusCtrl, updateSurveyInfoCtrl, updatePlanInfoCtrl } from "../control";
import {
  TableRow,
  TableCell,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  TextField, Typography, Checkbox, FormControlLabel, Chip, ListItemText
} from '@material-ui/core';
import SurveyTitleArea from "./SurveyTitleArea";
import SurveyContentContainer from "./SurveyContentContainer";
import SurveyPage from "./SurveyPage";
import classNames from "classnames";
import '../Styling/laundromat.css';
import MomentUtils from '@date-io/moment';
import {
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from '@material-ui/pickers';
import { SurveyStatusID, Months, IsL2, SelectCombosIBS } from '../Enums/constants'

let displayMap = {
  SurveyStatusID: SurveyStatusID,
}

const LaundromatPage = observer((props) => {

  if (ibsStore.currentSurvey) {
    if (ibsStore.currentSurvey.ProductID == 1) {
      if (!window.location.href.includes('/db')) {
        window.location.href = '/db/laundromat'
      }
    } else if (ibsStore.currentSurvey.ProductID == 2) {
      if (!window.location.href.includes('/dc')) {
        window.location.href = '/dc/laundromat'
      }
    }
  }


  let content;
  const isAnalyst = ibsStore.accountInfo?.UserRoleID == 3;
  if (isAnalyst) {
    content =
      <SurveyPage noFooter={true}>
        <SurveyTitleArea pageName="Laundromat" />
        <SurveyContentContainer>
          <div>
            <Laundromat />
          </div>
        </SurveyContentContainer>
      </SurveyPage>;
  } else {
    content = (
      <>
        You are not allowed to view this page.
      </>
    )
  }

  return content;
});

const Laundromat = observer(() => {

  const CustomChip = (props) => {
    let name = props.columnNames[props.index].name.toString();
    let value = props.label;

    if (displayMap[name] && displayMap[name][parseInt(value)]) {
      value = displayMap[name][parseInt(value)];
    }
    if (typeof value !== "undefined" && value !== null) {
      switch (name) {
        case "IsL2":
          value = value ? "True" : "False";
          break;
      }
    }

    const onStatusChange = async (surveyId, e) => {
        let statusId = e.target?.value;

        statusId = parseInt(e.target.value)
        if (!isNaN(statusId)) {
            await changeSurveyStatusCtrl(surveyId, statusId);
        }
    }

    const onCleanerChange = async (surveyId, e) => {
        await changeSurveyCleanerCtrl(surveyId, e.target.value)
    }

    const onSurveyInfoChange = async (surveyId, fieldName, e) => {
        const newValue = e.target.value;
        await updateSurveyInfoCtrl(surveyId, fieldName, newValue);
    }

    const onPlanInfoChange = async (surveyId, fieldName, e) => {
        const newValue = e.target.value;
        await updatePlanInfoCtrl(surveyId, fieldName, newValue);
    }

    const onCheckboxChange = async (surveyId, fieldName, newValue) => {
        let bit = newValue ? 1 : 0;
        await updateSurveyInfoCtrl(surveyId, fieldName, bit);
    }

    const onDateChange = async (surveyId, fieldName, date) => {
        await updateSurveyInfoCtrl(surveyId, fieldName, date, true);
    }

    const onLockDropdownChange = (event) => {
        const {
            target: { value },
        } = event;

        let surveyIndex = ibsStore?.surveysHistorical?.findIndex((survey) => survey.SurveyID === value[0]);
        if (surveyIndex > 0) {
            onCheckboxChange(ibsStore.surveysHistorical[surveyIndex].SurveyID, "IsLocked", !ibsStore.surveysHistorical[surveyIndex].IsLocked ?? true);
        }

    };

    // You need to make a Mui Theme to edit the size of font in a laundromat row
    const customFontSize = createMuiTheme({
        typography: {
            body1: {
                fontSize: 12,
                paddingTop:4,
            }
        }
    })

    const formSurveyCleaners = (survey) => {
        let cleaners = [];

        // White space in tag does not get saved to the database
        cleaners.push(<MenuItem value={null} >&nbsp;</MenuItem>);

        // Does the survey have a corresponding survey cleaner in the production database? If not, make the current cleaner an option but don't allow for further custom input
        if (typeof survey.SurveyCleanerID === "undefined" || survey.SurveyCleanerID === null) {
            cleaners.push(<MenuItem value={survey.SurveyCleaners} >{survey.SurveyCleaners}</MenuItem>);
        }

        // localeCompare used because it returns negative and positive numbers as the result of comparison, which is needed
        let sortedCleaners = [...store.surveyCleanersIBS].sort((a, b) => (a.firstName ?? "").toLowerCase().localeCompare(b.firstName?.toLowerCase() ?? ""));
        for (let cleaner of sortedCleaners) {
            cleaners.push(<MenuItem value={(cleaner.id ?? "")} >{(cleaner.firstName ?? "") + " " + (cleaner.lastName ?? "")}</MenuItem>);
        }

        return cleaners;
    }

    // Forces the mui Select dropdown elements to stay underneath the main element instead of appearing on top
    const menuPropsDropdown = {
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "left"
        },
        getContentAnchorEl: null
    };

    let formLockDropdown = (currentPlanID) => {

        let historicalData = ibsStore?.surveysHistorical?.filter((survey) => survey.PlanID === currentPlanID) ?? [];

        let elements = historicalData.map((survey) => (
            <MenuItem key={survey.SurveyID} value={survey.SurveyID} >
                <Checkbox checked={survey.IsLocked}/>
                <ListItemText primary={survey.DataYear.toString() + (survey.ProductID == 2 ? " DC" : " DB")} />
            </MenuItem>
        ));
        return elements;

    }


    const LaundromatTableExpandableRow = observer((props) => {
        const surveyId = props.surveyId;
        const colSpan = props.colSpan;

        const survey = store.surveyListDisplay.find(s => s.SurveyID === surveyId);
        let [noteContent2, changeNote] = useState(survey?.SurveyStatusMemo);
        const onChangeNote = (e) => {
            changeNote(e.target.value)
        }
      
        return <>
            <TableRow>
                <TableCell colSpan={colSpan}>
                    <Grid container spacing={2} style={{width: "100%", padding: "10px 10px 10px 10px"}}>
                        <Grid item xs={12}>
                            <Typography style={{ width: "100%", fontSize: "12px", alignItems: "center", display: "flex" }}>
                                <div style={{ width:"fit-content", fontSize: "1rem", display:"inline-block" }}>{survey.Plan} ({survey.DataYear}-{survey.Product})</div>

                                <FormControl>
                                    <MuiThemeProvider theme={customFontSize}>
                                        <FormControlLabel control={
                                            <Checkbox disabled checked={survey.IsNew} />
                                        } label="New" />
                                    </MuiThemeProvider>
                                </FormControl>

                                <FormControl>
                                    <MuiThemeProvider theme={customFontSize}>
                                        <FormControlLabel control={
                                            <Checkbox checked={survey.RecordkeeperDataUploaded}
                                                onChange={e => onCheckboxChange(surveyId, "RecordkeeperDataUploaded", !survey.RecordkeeperDataUploaded)} />
                                        } label="Recordkeeper Data Uploaded" />
                                    </MuiThemeProvider>
                                </FormControl>

                                <FormControl>
                                    <MuiThemeProvider theme={customFontSize}>
                                        <FormControlLabel control={
                                            <Checkbox checked={survey.IsL2}
                                                onChange={e => onCheckboxChange(surveyId, "IsL2", !survey.IsL2)} />
                                        } label="L2" />
                                    </MuiThemeProvider>
                                </FormControl>

                                <FormControl>
                                    <MuiThemeProvider theme={customFontSize}>
                                        <FormControlLabel control={
                                            <Checkbox checked={survey.IsFTEClean} onChange={e => onCheckboxChange(surveyId, "IsFTEClean", !survey.IsFTEClean)} />
                                        } label="FTE Clean" />
                                    </MuiThemeProvider>
                                </FormControl>
                                {survey.ProductID === 1 &&
                                    <FormControl>
                                        <MuiThemeProvider theme={customFontSize}>
                                            <FormControlLabel control={
                                                <Checkbox checked={survey.ForceTemplatesTab} onChange={e => onCheckboxChange(surveyId, "ForceTemplatesTab", !survey.ForceTemplatesTab)} />
                                            } label="Force Templates Tab" />
                                        </MuiThemeProvider>
                                    </FormControl>
                                }
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{"Last Year Survey Cleaner: " + survey.LastYearSurveyCleaners}
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {"   Error Count: " + survey.ErrorCount}
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{"MandateAllCount: " + survey.MandateAllCount}
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{"MandateWithDataCount: " + survey.MandateWithDataCount}
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{(typeof survey.ReturnMonth !== "undefined" && survey.ReturnMonth !== null && parseInt(survey.ReturnMonth) > 0 && parseInt(survey.ReturnMonth) <= 12) && "   Return Month: " + Months[parseInt(survey.ReturnMonth)]}
                            </Typography>
                        </Grid>



                        {/* SurveyStatusID // */}
                        <Grid item lg={3} md={4} xs={6}>
                            <FormControl style={{width: "100%"}}>
                                <InputLabel id="status-input-label">Status</InputLabel>
                                <Select
                                    labelId="status-input-label"
                                    id="cleaner-input"
                                    value={survey.SurveyStatusID}
                                    MenuProps={menuPropsDropdown}
                                    onChange={(e) => onStatusChange(surveyId, e)}
                                >
                                    <MenuItem value={null} >&nbsp;</MenuItem>
                                    <MenuItem value="1" >Done</MenuItem>
                                    <MenuItem value="2" >Web Validated</MenuItem>
                                    <MenuItem value="3" >Don't Use</MenuItem>
                                    <MenuItem value="4" >Needs Work</MenuItem>
                                    <MenuItem value="5" >See memo</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* SurveyCleaners */}
                        <Grid item lg={3} md={4} xs={6}>

                            <FormControl style={{ width: "100%" }}>
                                <InputLabel id="cleaner-input-label">Cleaner</InputLabel>
                                <Select
                                    labelId="media-type-input-label"
                                    id="cleaner-input"
                                    value={survey.SurveyCleanerID ?? survey.SurveyCleaners}
                                    MenuProps={menuPropsDropdown}
                                    onChange={(e) => onCleanerChange(surveyId, e)}
                                >
                                    {formSurveyCleaners(survey)}
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* OriginalDateCompleted */}
                        <Grid item lg={3} md={4} xs={6}>
                            <FormControl style={{width: "100%"}}>
                                <KeyboardDateTimePicker
                                    margin="none"
                                    id="date-first-submitted"
                                    label="First Submitted"
                                    format="yyyy/MM/DD hh:mm a"
                                    value={survey.OriginalDateCompleted != null ? new Date(survey.OriginalDateCompleted) : null}
                                    onChange={e => onDateChange(surveyId, "OriginalDateCompleted", e?.toDate())}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}/>
                            </FormControl>
                        </Grid>

                        {/* Question sent date: */}
                        <Grid item lg={3} md={4} xs={6}>
                            <FormControl style={{width: "100%"}}>
                                <KeyboardDateTimePicker
                                    margin="none"
                                    id="date-first-done"
                                    label="Question Sent Date"
                                    format="yyyy/MM/DD hh:mm a"
                                    value={survey.DateQuestionSent != null ? new Date(survey.DateQuestionSent) : null}
                                    onChange={e => onDateChange(surveyId, "DateQuestionSent", e?.toDate())}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}/>
                            </FormControl>
                        </Grid>
                        
                        {/* MediaTypeID */}
                        <Grid item lg={3} md={4} xs={6}>
                            <FormControl style={{ width: "100%", paddingTop: survey.ProductID == 2 ? "19px" : "0px"}}>
                                <InputLabel id="media-type-input-label">Media</InputLabel>
                                <Select
                                    labelId="media-type-input-label"
                                    id="media-type-input"
                                    value={survey.MediaTypeID}
                                    onChange={(e) => onSurveyInfoChange(surveyId, "MediaTypeID", e)}
                                    MenuProps={menuPropsDropdown}
                                >
                                    <MenuItem value={null} >&nbsp;</MenuItem>
                                    <MenuItem value="1" >Web</MenuItem>
                                    <MenuItem value="3" >Excel</MenuItem>
                                    <MenuItem value="4" >Other</MenuItem>
                                    <MenuItem value="9" >Templates (CEM collected)</MenuItem>
                                    <MenuItem value="10" >Templates (Client collected)</MenuItem>
                                    <MenuItem value="11" >Templates (3rd Party collected)</MenuItem>
                                    <MenuItem value="12" >Custodian</MenuItem>
                                    <MenuItem value="13" >Recordkeeper</MenuItem>
                                    <MenuItem value="14" >Client filled CEM Template</MenuItem>
                                    <MenuItem value="15" >Consultant</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        
                        {/* PublicCorpOtherID */}
                        <Grid item lg={3} md={4} xs={6}>
                            <FormControl style={{ width: "100%", paddingTop: survey.ProductID == 2 ? "19px": "0px"}}>
                                <InputLabel id="public-corp-other-input-label">Public/Corp/Other</InputLabel>
                                <Select
                                    labelId="public-corp-other-input-label"
                                    id="public-corp-other-input"
                                    value={survey.PublicCorpOtherID}
                                    MenuProps={menuPropsDropdown}
                                    onChange={(e) => onPlanInfoChange(surveyId, "PublicCorpOtherID", e)}
                                    >
                                    <MenuItem value={null}>&nbsp;</MenuItem>
                                    <MenuItem value="1">Public</MenuItem>
                                    <MenuItem value="2">Corporate</MenuItem>
                                    <MenuItem value="3">Other</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* EnhancedInternalID */}
                        {survey.ProductID != 2 &&
                            <Grid item lg={3} md={4} xs={6}>
                            <FormControl style={{ width: "100%" }}>
                                <InputLabel id="enhanced-internal-input-label">Enhanced FTE/Custom Assets</InputLabel>
                                <Select
                                    labelId="enhanced-internal-input-label"
                                    id="enhanced-internal-input"
                                    value={survey.EnhancedInternalID}
                                    MenuProps={menuPropsDropdown}
                                    onChange={(e) => onSurveyInfoChange(surveyId, "EnhancedInternalID", e)}
                                    disabled={survey.ProductID == 2}
                                >
                                    {mapMenuItems(SelectCombosIBS.ENHANCED_SURVEY_OPTIONS, "EnhancedInternalID", "EnhancedInternalName")}

                                </Select>
                            </FormControl>
                        </Grid>
                        }
                        
                        {/* PrivateEquityStatusTypeID */}
                        {survey.ProductID != 2 &&
                            <Grid item lg={3} md={4} xs={6}>
                                <FormControl style={{ width: "100%" }}>
                                    <InputLabel id="private-equity-status-type-input-label">LP Survey Status</InputLabel>
                                    <Select
                                        labelId="private-equity-status-type-input-label"
                                        id="private-equity-status-type-input"
                                        value={survey.PrivateEquityStatusTypeID}
                                        MenuProps={menuPropsDropdown}
                                        onChange={(e) => onSurveyInfoChange(surveyId, "PrivateEquityStatusTypeID", e)}
                                        disabled={survey.ProductID == 2}
                                    >
                                        <MenuItem value={null}>&nbsp;</MenuItem>
                                        <MenuItem value="1">Done</MenuItem>
                                        <MenuItem value="2">Needs Work</MenuItem>
                                        <MenuItem value="3">Don't Use</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        }

                        <Grid item lg={3} md={4} xs={6}>
                            <FormControl style={{ width: "100%", paddingTop: '19px'}}>
                                <InputLabel id="locking-input">Select Surveys to Lock</InputLabel>
                                <Select
                                    labelId="locking-label"
                                    id="locking-ID"
                                    multiple
                                    value={[]}
                                    onChange={onLockDropdownChange}
                                    MenuProps={menuPropsDropdown}
                                    renderValue={() => "Select Surveys to Lock"}
                                >
                                    {formLockDropdown(survey.PlanID)}
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* SurveyStatusMemo */}
                        <Grid item lg={3} md={4} xs={6}>
                            <FormControl style={{ width: "100%" }}>
                                <TextField id="standard-textarea" label="Notes" multiline={true}  value={noteContent2}
                                    onChange={e => onChangeNote(e)} onBlur={e => onSurveyInfoChange(surveyId, "SurveyStatusMemo", e)} />

                            </FormControl>

                        </Grid>

                    </Grid>
                </TableCell>
            </TableRow>
        </>

    })

    //e => onSurveyInfoChange(surveyId, "SurveyStatusMemo", e)
    //{/* HasUserConfirmedDefaults */ }
    //<Grid item lg={3} md={4} xs={6}>
    //    <FormControl style={{ width: "100%" }}>
    //        <InputLabel id="user-confirmed-defaults-input-label">Has User Confirmed Defaults</InputLabel>
    //        <Select
    //            labelId="user-confirmed-defaults-input-label"
    //            id="user-confirmed-defaults-input"
    //            value={survey.HasUserConfirmedDefaults}
    //            onChange={(e) => onSurveyInfoChange(surveyId, "HasUserConfirmedDefaults", e)}
    //        >
    //            <MenuItem value={null}>&nbsp;</MenuItem>
    //            <MenuItem value="1">Yes</MenuItem>
    //            <MenuItem value="2">No</MenuItem>
    //            <MenuItem value="3">N/A</MenuItem>
    //        </Select>
    //    </FormControl>
    //</Grid>

    function cleanerStr(surveyId) {
        const survey = store.surveyListDisplay.find(s => s.SurveyID == surveyId);
        let cleanerStr = "";

        // Shouldn't ever be undefined or null, but just incase
        if (typeof survey === "undefined" || survey === null) {
            return <></>;
        }

        // Use legacy user string if no ID defined
        if ((typeof survey.SurveyCleanerID === "undefined" || survey.SurveyCleanerID === null) && typeof survey.SurveyCleaners === "string") {
            cleanerStr = survey.SurveyCleaners;
        }
        else if (survey.SurveyCleanerID in store.surveyCleanersMapIBS) {
            let cleaner = store.surveyCleanersMapIBS[survey.SurveyCleanerID]
            cleanerStr = (cleaner.firstName ?? "") + " " + (cleaner.lastName ?? "");
        }
        return cleanerStr;
    }
    const CleanerDataColumn = observer((props) => {
        return <>{cleanerStr(props.surveyId)}</>
    });
    
    const StatusDataColumn = observer((props) => {
        const surveyId = props.surveyId;
        const survey = store.surveyListDisplay.find(s => s.SurveyID == surveyId);

        // Shouldn't ever be undefined or null, but just incase
        if (typeof survey === "undefined" || survey === null || !(survey?.SurveyStatusID in displayMap.SurveyStatusID)) {
            return <></>;
        }

        const status = displayMap.SurveyStatusID[survey.SurveyStatusID];
        return <>{status}</>
    });

    const L2DataColumn = observer((props) => {
        const surveyId = props.surveyId;
        const survey = store.surveyListDisplay.find(s => s.SurveyID == surveyId);
        return <>{survey.IsL2 ? "True":"False"}</>
    });
    
    const LaundromatTable = observer(() => {
        const muiTheme = () => createMuiTheme({
            overrides: {
                MUIDataTableSelectCell: {
                    headerCell: {
                        backgroundColor: "rgb(91, 100, 109)",
                        color: "#FFFFFF"
                    }
                },
                MuiButton: {
                    root: {
                        color: "#FFFFFF"
                    }
                },
                MuiSelect: {
                    select: {
                        minWidth: "60px"
                    }
                },
                MUIDataTableBodyRow: {
                    root: {
                        // height: "43px",
                        '&:hover': {
                            cursor: "pointer"
                        }
                    },
                },
                MUIDataTableBodyCell: {
                    root: {
                        textOverflow: "ellipsis",
                        textAlign: "left",
                        whiteSpace: "nowrap",
                        overflow: "hidden"
                    }
                },
                MuiTablePagination: {
                    caption: {
                        color: "#467175",
                        fontSize: "0.75rem"
                    }
                },
                MUIDataTableHeadCell: {
                    root: {
                        backgroundColor: "rgb(91, 100, 109)",
                        color: "#FFFFFF",
                        textAlign: "left",
                    },
                    fixedHeader: {
                        backgroundColor: "rgb(91, 100, 109)",
                        color: "#FFFFFF",
                        textAlign: "left",
                    },
                    button: {
                        color: "#FFFFFF",
                        textAlign: "center"
                    },
                    sortActive: {
                        color: "#FFFFFF"
                    },
                    toolButton: {
                        marginLeft: 0
                    },
                    contentWrapper: {
                        display: "block",
                        margin: "0 auto"
                    }
                },
                MUIDataTable: {
                    paper: {
                        height: '100%',
                    },
                    responsiveScroll: {
                        maxHeight: 'none',
                        height: 'calc(100% - 128px)'
                    },
                    tableRoot: {
                        tableLayout: "fixed"
                    }
                },
                MUIDataTableToolbar: {
                    titleRoot: {
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        alignItems: "center"
                    }
                }
            }
        });
        const columns = [
            {
                name: "SurveyID",
                options: {
                    filter: false,
                    display: false
                }
            },
            {
                name: "",
                options: {
                    filter: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let rowData = tableMeta.currentTableData[tableMeta.rowIndex].data;
                        let surveyId = rowData[0];
                        return <div style={{ width: "100%", height: "100%", display: "inline-block" }} > <button style={{ width: "fit-content", height: "80%", fontSize: "13px" }} class="btn btn-add-row" onClick={() => { setBlockRowExpansion(true); beam(surveyId); }}><i class="fa fa-lg fa-sign-in-alt fa-nohover2" aria-hidden="true"></i></button></div>
                    }
                }
            },
            {
                label: "Plan",
                name: "Plan",
                editable: "never",
                options: {
                    filter: false,
                },
                render: rowData => <>{rowData.Plan}</>
            },
            {
                label: "Partnership",
                name: "PlanPartnershipNameShort",
                editable: "never",
                options: {

                    filter: true,
                    filterType: 'multiselect'
                },
                render: rowData => <>{rowData.PlanPartnershipNameShort}</>
            },
            {
                label: "Product",
                name: "Product",
                editable: "never",
                options: {
                    filter: true,
                    filterType: 'multiselect'
                },
                render: rowData => <>{rowData.Product}</>
            },
            {
                label: "Country",
                editable: "never",
                name: "CountryName",
                options: {
                    filter: true,
                    filterType: 'multiselect'
                }
            },
            {
                label: "Questions Sent",
                editable: "never",
                name: "DateQuestionSent",
                options: {
                    filter: false,
                    customBodyRender: value => {
                        if (value) {
                            let date = new Date(value);
                            return <>{formatAMPM(date)}</>;
                        }
                    }
                },
            },
            {
                label: "DataYear",
                editable: "never",
                name: "DataYear",
                options: {
                    filter: true,
                    filterType: 'multiselect'
                }
            },
            {
                editable: "never",
                label: "Received",
                name: "OriginalDateCompleted",
                options: {
                    filter: false,
                    customBodyRender: value => {
                        if (value) {
                            let date = new Date(value);
                            return <>{formatAMPM(date)}</>;
                        }
                    }
                },
            },
            {
                label: "Active",
                editable: "never",
                name: "LatestActivity",
                options: {
                    filter: false,
                    sortDirection: 'asc',
                    customBodyRender: value => {
                        if (value) {
                            let date = new Date(value);
                            return <>{formatAMPM(date)}</>;
                        }
                    }
                },
            },
            {
                label: "Changes",
                name: "NumChanges",
                editable: "never",
                options: {
                    filter: false,
                },
            },
            {
                label: "Survey Status",
                name: "SurveyStatusID",
                options: {
                    filter: true,
                    filterType: 'multiselect',
                    filterOptions: {
                        renderValue: v => {
                            return displayMap.SurveyStatusID[v] ?? "No Status";
                        }
                    },
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let rowData = tableMeta.currentTableData[tableMeta.rowIndex].data;
                        let surveyId = rowData[0];
                        return <StatusDataColumn surveyId={surveyId} />;
                    }
                },
            },
            {
                label: "Cleaner",
                name: "SurveyCleanersMixed",
                options: {
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let rowData = tableMeta.currentTableData[tableMeta.rowIndex].data;
                        let surveyId = rowData[0];
                        return <CleanerDataColumn value={cleanerStr(surveyId)} surveyId={surveyId} />

                    },
                    filter: true,
                    filterType: 'multiselect',
                },
            },
            {
                label: "L2 Status",
                editable: "never",
                name: "IsL2",
                options: {
                    filter: true,
                    filterType: 'multiselect',
                    filterOptions: {
                        renderValue: v => {
                            return v ? "True" : "False";
                        }
                    },
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let rowData = tableMeta.currentTableData[tableMeta.rowIndex].data;
                        let surveyId = rowData[0];
                        return <L2DataColumn surveyId={surveyId} />
                    }
                },
            }
        ];
        
        const laundroref = useRef(null);
        const [blockRowExpansion, setBlockRowExpansion] = useState(false);
        return (
            <>
                <MuiPickersUtilsProvider utils={MomentUtils} locale={"en"}>
                <MuiThemeProvider theme={muiTheme()}>
                    <div id="laundromat-page-table">
                            <MaterialTable
                                title={
                                    <div className="MUIDataTableToolbar-titleRoot-19" aria-hidden="true">
                                        <h6 className="MuiTypography-root MUIDataTableToolbar-titleText-20 MuiTypography-h6">Laundromat</h6>
                                    </div>
                                }
                                ref={laundroref}
                                options={{
                                    draggable: false,
                                    pagination: true,
                                    rowsPerPage: 100,
                                    selectableRows: "single",
                                    selectableRowsHeader: false,
                                    selectableRowsHideCheckboxes: true,
                                    selectToolbarPlacement: "none",
                                    filter: true,
                                    print: false,
                                    download: false,
                                    viewColumns: true,
                                    fixedHeader: true,
                                    tableBodyMaxHeight: "95%",
                                    tableBodyHeight: "100%",
                                    textLabels: {
                                        pagination: {
                                            next: "Next Page",
                                            previous: "Previous Page",
                                            rowsPerPage: "",
                                            displayRows: "of",
                                        }
                                    },
                                    expandableRows: true,
                                    expandableRowsHeader: false,
                                    expandableRowsOnClick: true,
                                    isRowExpandable: (dataIndex, expandedRows) => {
                                        if (!blockRowExpansion) {
                                            return true;
                                        }
                                        return false;
                                        
                                    },
                                    rowsExpanded: [],
                                    renderExpandableRow: (tableRowData, rowMeta) => {
                                        const colSpan = tableRowData.length;
                                        const surveyId = tableRowData[0];
                                        return <LaundromatTableExpandableRow colSpan={colSpan} surveyId={surveyId} />;
                                    },
                                    onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) => {
                                        // Only display one row. If a row is expanded that puts the row count above 1, toggle all rows except the last opened row.

                                        if (allExpanded?.length > 1 && curExpanded.length > 0) {
                                            for (let rowX of allExpanded) {
                                                if (rowX.index != curExpanded[0].index || blockRowExpansion === true) {
                                                    laundroref.current.toggleExpandRow(rowX);
                                                }
                                            }
                                        }
                                    },
                                }}
                                columns={columns}
                                data={store?.surveyListDisplay}
                                components={{
                                    TableFilterList: CustomFilterList,
                                }}
                        /></div>
                </MuiThemeProvider>
                </MuiPickersUtilsProvider>
            </>
        )
    })
    return (
      <Chip
        variant="outlined"
        color="primary"
        label={value}
        onDelete={props.onDelete}
      />
    );
  };
  const CustomFilterList = (props) => {
    return <div style={{ padding: "10px" }}><TableFilterList {...props} ItemComponent={CustomChip} /></div>;
  };

  const mapMenuItems = (items, optionId, optionText) => {

    const optionElements = Object.entries(items).map(([key, value]) => (
      <MenuItem key={key} value={key}>
        {value}
      </MenuItem>
    ));
    return optionElements;
  };

  const beam = async (surveyIdOfSelectedRow) => {
    const rowData = store.surveyListDisplay.find(s => s.SurveyID === surveyIdOfSelectedRow);
    store.viewSurveyDetails = false;
    const surveyId = rowData.SurveyID;
    const planId = rowData.PlanID;
    const dataYear = rowData.DataYear;
    const productFromSelectedRow = rowData.Product;

    if (productFromSelectedRow === 'DC') {
      localStorage.removeItem("lastOpenedSurveyIdCacheDB");
      window.location.href = '/dc/home';
      localStorage.setItem("lastOpenedSurveyIdCacheDC", surveyId);
      localStorage.setItem("lastOpenedPlanID", planId);
      localStorage.setItem("lastOpenedProductType", productFromSelectedRow);
      return;

    } else if (productFromSelectedRow === 'DB') {
      window.location.href = '/db/home';
      localStorage.removeItem("lastOpenedSurveyIdCacheDC");
      localStorage.setItem("lastOpenedSurveyIdCacheDB", surveyId);
      localStorage.setItem("lastOpenedPlanID", planId);
      localStorage.setItem("lastOpenedProductType", productFromSelectedRow);
      return;

    }

    // reset template flagging flag
    store.templateExistingFirstLoad = true;

    // beam me up scotty
    await changeSurveyCtrl(surveyId, planId, productFromSelectedRow);
  }

  const onStatusChange = async (surveyId, e) => {
    let statusId = e.target?.value;

    statusId = parseInt(e.target.value)
    if (!isNaN(statusId)) {
      await changeSurveyStatusCtrl(surveyId, statusId);
    }
  }

  const onCleanerChange = async (surveyId, e) => {
    await changeSurveyCleanerCtrl(surveyId, e.target.value)
  }

  const onSurveyInfoChange = async (surveyId, fieldName, e) => {
    const newValue = e.target.value;
    await updateSurveyInfoCtrl(surveyId, fieldName, newValue);
  }

  const onPlanInfoChange = async (surveyId, fieldName, e) => {
    const newValue = e.target.value;
    await updatePlanInfoCtrl(surveyId, fieldName, newValue);
  }

  const onCheckboxChange = async (surveyId, fieldName, newValue) => {
    let bit = newValue ? 1 : 0;
    await updateSurveyInfoCtrl(surveyId, fieldName, bit);
  }

  const onDateChange = async (surveyId, fieldName, date) => {
    await updateSurveyInfoCtrl(surveyId, fieldName, date, true);
  }

  const onLockDropdownChange = (event) => {
    const {
      target: { value },
    } = event;

    let surveyIndex = ibsStore?.surveysHistorical?.findIndex((survey) => survey.SurveyID === value[0]);
    if (surveyIndex > 0) {
      onCheckboxChange(ibsStore.surveysHistorical[surveyIndex].SurveyID, "IsLocked", !ibsStore.surveysHistorical[surveyIndex].IsLocked ?? true);
    }

  };

  // You need to make a Mui Theme to edit the size of font in a laundromat row
  const customFontSize = createMuiTheme({
    typography: {
      body1: {
        fontSize: 12,
        paddingTop: 4,
      }
    }
  })

  const formSurveyCleaners = (survey) => {
    let cleaners = [];

    // White space in tag does not get saved to the database
    cleaners.push(<MenuItem value={null} >&nbsp;</MenuItem>);

    // Does the survey have a corresponding survey cleaner in the production database? If not, make the current cleaner an option but don't allow for further custom input
    if (typeof survey.SurveyCleanerID === "undefined" || survey.SurveyCleanerID === null) {
      cleaners.push(<MenuItem value={survey.SurveyCleaners} >{survey.SurveyCleaners}</MenuItem>);
    }

    // localeCompare used because it returns negative and positive numbers as the result of comparison, which is needed
    let sortedCleaners = [...store.surveyCleanersIBS].sort((a, b) => (a.firstName ?? "").toLowerCase().localeCompare(b.firstName?.toLowerCase() ?? ""));
    for (let cleaner of sortedCleaners) {
      cleaners.push(<MenuItem value={(cleaner.id ?? "")} >{(cleaner.firstName ?? "") + " " + (cleaner.lastName ?? "")}</MenuItem>);
    }

    return cleaners;
  }

  // Forces the mui Select dropdown elements to stay underneath the main element instead of appearing on top
  const menuPropsDropdown = {
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    },
    getContentAnchorEl: null
  };

  //this forces the filter options to also drop down under their element, with Paper forcing it to be scrollable so that it doesn't autobalance itself into overlapping
  const ITEM_HEIGHT = 48;
  const filterMenuPropsDropdown = {
    ...menuPropsDropdown,
    PaperProps: {
      style: { maxHeight: ITEM_HEIGHT * 4 }
    }
  };

  let formLockDropdown = (currentPlanID) => {

    let historicalData = ibsStore?.surveysHistorical?.filter((survey) => survey.PlanID === currentPlanID) ?? [];

    let elements = historicalData.map((survey) => (
      <MenuItem key={survey.SurveyID} value={survey.SurveyID} >
        <Checkbox checked={survey.IsLocked} />
        <ListItemText primary={survey.DataYear.toString() + (survey.ProductID == 2 ? " DC" : " DB")} />
      </MenuItem>
    ));
    return elements;

  }


  const LaundromatTableExpandableRow = observer((props) => {
    const surveyId = props.surveyId;
    const colSpan = props.colSpan;

    const survey = store.surveyListDisplay.find(s => s.SurveyID === surveyId);
    let [noteContent2, changeNote] = useState(survey?.SurveyStatusMemo);
    const onChangeNote = (e) => {
      changeNote(e.target.value)
    }

    return <>
      <TableRow>
        <TableCell colSpan={colSpan}>
          <Grid container spacing={2} style={{ width: "100%", padding: "10px 10px 10px 10px" }}>
            <Grid item xs={12}>
              <Typography style={{ width: "100%", fontSize: "12px", alignItems: "center", display: "flex" }}>
                <div style={{ width: "fit-content", fontSize: "1rem", display: "inline-block" }}>{survey.Plan} ({survey.DataYear}-{survey.Product})</div>

                <FormControl>
                  <MuiThemeProvider theme={customFontSize}>
                    <FormControlLabel control={
                      <Checkbox disabled checked={survey.IsNew} />
                    } label="New" />
                  </MuiThemeProvider>
                </FormControl>

                <FormControl>
                  <MuiThemeProvider theme={customFontSize}>
                    <FormControlLabel control={
                      <Checkbox checked={survey.RecordkeeperDataUploaded}
                        onChange={e => onCheckboxChange(surveyId, "RecordkeeperDataUploaded", !survey.RecordkeeperDataUploaded)} />
                    } label="Recordkeeper Data Uploaded" />
                  </MuiThemeProvider>
                </FormControl>

                <FormControl>
                  <MuiThemeProvider theme={customFontSize}>
                    <FormControlLabel control={
                      <Checkbox checked={survey.IsL2}
                        onChange={e => onCheckboxChange(surveyId, "IsL2", !survey.IsL2)} />
                    } label="L2" />
                  </MuiThemeProvider>
                </FormControl>

                <FormControl>
                  <MuiThemeProvider theme={customFontSize}>
                    <FormControlLabel control={
                      <Checkbox checked={survey.IsFTEClean} onChange={e => onCheckboxChange(surveyId, "IsFTEClean", !survey.IsFTEClean)} />
                    } label="FTE Clean" />
                  </MuiThemeProvider>
                </FormControl>
                {survey.ProductID === 1 &&
                  <FormControl>
                    <MuiThemeProvider theme={customFontSize}>
                      <FormControlLabel control={
                        <Checkbox checked={survey.ForceTemplatesTab} onChange={e => onCheckboxChange(surveyId, "ForceTemplatesTab", !survey.ForceTemplatesTab)} />
                      } label="Force Templates Tab" />
                    </MuiThemeProvider>
                  </FormControl>
                }
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{"Last Year Survey Cleaner: " + survey.LastYearSurveyCleaners}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  {"   Error Count: " + survey.ErrorCount}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{"MandateAllCount: " + survey.MandateAllCount}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{"MandateWithDataCount: " + survey.MandateWithDataCount}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{(typeof survey.ReturnMonth !== "undefined" && survey.ReturnMonth !== null && parseInt(survey.ReturnMonth) > 0 && parseInt(survey.ReturnMonth) <= 12) && "   Return Month: " + Months[parseInt(survey.ReturnMonth)]}
              </Typography>
            </Grid>



            {/* SurveyStatusID // */}
            <Grid item lg={3} md={4} xs={6}>
              <FormControl style={{ width: "100%" }}>
                <InputLabel id="status-input-label">Status</InputLabel>
                <Select
                  labelId="status-input-label"
                  id="cleaner-input"
                  value={survey.SurveyStatusID}
                  MenuProps={menuPropsDropdown}
                  onChange={(e) => onStatusChange(surveyId, e)}
                >
                  <MenuItem value={null} >&nbsp;</MenuItem>
                  <MenuItem value="1" >Done</MenuItem>
                  <MenuItem value="2" >Web Validated</MenuItem>
                  <MenuItem value="3" >Don't Use</MenuItem>
                  <MenuItem value="4" >Needs Work</MenuItem>
                  <MenuItem value="5" >See memo</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* SurveyCleaners */}
            <Grid item lg={3} md={4} xs={6}>

              <FormControl style={{ width: "100%" }}>
                <InputLabel id="cleaner-input-label">Cleaner</InputLabel>
                <Select
                  labelId="media-type-input-label"
                  id="cleaner-input"
                  value={survey.SurveyCleanerID ?? survey.SurveyCleaners}
                  MenuProps={menuPropsDropdown}
                  onChange={(e) => onCleanerChange(surveyId, e)}
                >
                  {formSurveyCleaners(survey)}
                </Select>
              </FormControl>
            </Grid>

            {/* OriginalDateCompleted */}
            <Grid item lg={3} md={4} xs={6}>
              <FormControl style={{ width: "100%" }}>
                <KeyboardDateTimePicker
                  margin="none"
                  id="date-first-submitted"
                  label="First Submitted"
                  format="yyyy/MM/DD hh:mm a"
                  value={survey.OriginalDateCompleted != null ? new Date(survey.OriginalDateCompleted) : null}
                  onChange={e => onDateChange(surveyId, "OriginalDateCompleted", e?.toDate())}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }} />
              </FormControl>
            </Grid>

            {/* Question sent date: */}
            <Grid item lg={3} md={4} xs={6}>
              <FormControl style={{ width: "100%" }}>
                <KeyboardDateTimePicker
                  margin="none"
                  id="date-first-done"
                  label="Question Sent Date"
                  format="yyyy/MM/DD hh:mm a"
                  value={survey.DateQuestionSent != null ? new Date(survey.DateQuestionSent) : null}
                  onChange={e => onDateChange(surveyId, "DateQuestionSent", e?.toDate())}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }} />
              </FormControl>
            </Grid>

            {/* MediaTypeID */}
            <Grid item lg={3} md={4} xs={6}>
              <FormControl style={{ width: "100%", paddingTop: survey.ProductID == 2 ? "19px" : "0px" }}>
                <InputLabel id="media-type-input-label">Media</InputLabel>
                <Select
                  labelId="media-type-input-label"
                  id="media-type-input"
                  value={survey.MediaTypeID}
                  onChange={(e) => onSurveyInfoChange(surveyId, "MediaTypeID", e)}
                  MenuProps={menuPropsDropdown}
                >
                  <MenuItem value={null} >&nbsp;</MenuItem>
                  <MenuItem value="1" >Web</MenuItem>
                  <MenuItem value="3" >Excel</MenuItem>
                  <MenuItem value="4" >Other</MenuItem>
                  <MenuItem value="9" >Templates (CEM collected)</MenuItem>
                  <MenuItem value="10" >Templates (Client collected)</MenuItem>
                  <MenuItem value="11" >Templates (3rd Party collected)</MenuItem>
                  <MenuItem value="12" >Custodian</MenuItem>
                  <MenuItem value="13" >Recordkeeper</MenuItem>
                  <MenuItem value="14" >Client filled CEM Template</MenuItem>
                  <MenuItem value="15" >Consultant</MenuItem>
                </Select>
              </FormControl>
            </Grid>


            {/* PublicCorpOtherID */}
            <Grid item lg={3} md={4} xs={6}>
              <FormControl style={{ width: "100%", paddingTop: survey.ProductID == 2 ? "19px" : "0px" }}>
                <InputLabel id="public-corp-other-input-label">Public/Corp/Other</InputLabel>
                <Select
                  labelId="public-corp-other-input-label"
                  id="public-corp-other-input"
                  value={survey.PublicCorpOtherID}
                  MenuProps={menuPropsDropdown}
                  onChange={(e) => onPlanInfoChange(surveyId, "PublicCorpOtherID", e)}
                >
                  <MenuItem value={null}>&nbsp;</MenuItem>
                  <MenuItem value="1">Public</MenuItem>
                  <MenuItem value="2">Corporate</MenuItem>
                  <MenuItem value="3">Other</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* EnhancedInternalID */}
            {survey.ProductID != 2 &&
              <Grid item lg={3} md={4} xs={6}>
                <FormControl style={{ width: "100%" }}>
                  <InputLabel id="enhanced-internal-input-label">Enhanced Internal</InputLabel>
                  <Select
                    labelId="enhanced-internal-input-label"
                    id="enhanced-internal-input"
                    value={survey.EnhancedInternalID}
                    MenuProps={menuPropsDropdown}
                    onChange={(e) => onSurveyInfoChange(surveyId, "EnhancedInternalID", e)}
                    disabled={survey.ProductID == 2}
                  >
                    {mapMenuItems(SelectCombosIBS.ENHANCED_SURVEY_OPTIONS, "EnhancedInternalID", "EnhancedInternalName")}

                  </Select>
                </FormControl>
              </Grid>
            }

            {/* PrivateEquityStatusTypeID */}
            {survey.ProductID != 2 &&
              <Grid item lg={3} md={4} xs={6}>
                <FormControl style={{ width: "100%" }}>
                  <InputLabel id="private-equity-status-type-input-label">Private Equity Status</InputLabel>
                  <Select
                    labelId="private-equity-status-type-input-label"
                    id="private-equity-status-type-input"
                    value={survey.PrivateEquityStatusTypeID}
                    MenuProps={menuPropsDropdown}
                    onChange={(e) => onSurveyInfoChange(surveyId, "PrivateEquityStatusTypeID", e)}
                    disabled={survey.ProductID == 2}
                  >
                    <MenuItem value={null}>&nbsp;</MenuItem>
                    <MenuItem value="1">Done</MenuItem>
                    <MenuItem value="2">Needs Work</MenuItem>
                    <MenuItem value="3">Don't Use</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            }

            <Grid item lg={3} md={4} xs={6}>
              <FormControl style={{ width: "100%", paddingTop: '19px' }}>
                <InputLabel id="locking-input">Select Surveys to Lock</InputLabel>
                <Select
                  labelId="locking-label"
                  id="locking-ID"
                  multiple
                  value={[]}
                  onChange={onLockDropdownChange}
                  MenuProps={menuPropsDropdown}
                  renderValue={() => "Select Surveys to Lock"}
                >
                  {formLockDropdown(survey.PlanID)}
                </Select>
              </FormControl>
            </Grid>

            {/* SurveyStatusMemo */}
            <Grid item lg={3} md={4} xs={6}>
              <FormControl style={{ width: "100%" }}>
                <TextField id="standard-textarea" label="Notes" multiline={true} value={noteContent2}
                  onChange={e => onChangeNote(e)} onBlur={e => onSurveyInfoChange(surveyId, "SurveyStatusMemo", e)} />

              </FormControl>

            </Grid>

          </Grid>
        </TableCell>
      </TableRow>
    </>

  })

  //e => onSurveyInfoChange(surveyId, "SurveyStatusMemo", e)
  //{/* HasUserConfirmedDefaults */ }
  //<Grid item lg={3} md={4} xs={6}>
  //    <FormControl style={{ width: "100%" }}>
  //        <InputLabel id="user-confirmed-defaults-input-label">Has User Confirmed Defaults</InputLabel>
  //        <Select
  //            labelId="user-confirmed-defaults-input-label"
  //            id="user-confirmed-defaults-input"
  //            value={survey.HasUserConfirmedDefaults}
  //            onChange={(e) => onSurveyInfoChange(surveyId, "HasUserConfirmedDefaults", e)}
  //        >
  //            <MenuItem value={null}>&nbsp;</MenuItem>
  //            <MenuItem value="1">Yes</MenuItem>
  //            <MenuItem value="2">No</MenuItem>
  //            <MenuItem value="3">N/A</MenuItem>
  //        </Select>
  //    </FormControl>
  //</Grid>

  function cleanerStr(surveyId) {
    const survey = store.surveyListDisplay.find(s => s.SurveyID == surveyId);
    let cleanerStr = "";

    // Shouldn't ever be undefined or null, but just incase
    if (typeof survey === "undefined" || survey === null) {
      return <></>;
    }

    // Use legacy user string if no ID defined
    if ((typeof survey.SurveyCleanerID === "undefined" || survey.SurveyCleanerID === null) && typeof survey.SurveyCleaners === "string") {
      cleanerStr = survey.SurveyCleaners;
    }
    else if (survey.SurveyCleanerID in store.surveyCleanersMapIBS) {
      let cleaner = store.surveyCleanersMapIBS[survey.SurveyCleanerID]
      cleanerStr = (cleaner.firstName ?? "") + " " + (cleaner.lastName ?? "");
    }
    return cleanerStr;
  }
  const CleanerDataColumn = observer((props) => {
    return <>{cleanerStr(props.surveyId)}</>
  });

  const StatusDataColumn = observer((props) => {
    const surveyId = props.surveyId;
    const survey = store.surveyListDisplay.find(s => s.SurveyID == surveyId);

    // Shouldn't ever be undefined or null, but just incase
    if (typeof survey === "undefined" || survey === null || !(survey?.SurveyStatusID in displayMap.SurveyStatusID)) {
      return <></>;
    }

    const status = displayMap.SurveyStatusID[survey.SurveyStatusID];
    return <>{status}</>
  });

  const L2DataColumn = observer((props) => {
    const surveyId = props.surveyId;
    const survey = store.surveyListDisplay.find(s => s.SurveyID == surveyId);
    return <>{survey.IsL2 ? "True" : "False"}</>
  });

  const LaundromatTable = observer(() => {
    const muiTheme = () => createMuiTheme({
      overrides: {
        MUIDataTableSelectCell: {
          headerCell: {
            backgroundColor: "rgb(91, 100, 109)",
            color: "#FFFFFF"
          }
        },
        MuiButton: {
          root: {
            color: "#FFFFFF"
          }
        },
        MuiSelect: {
          select: {
            minWidth: "60px"
          }
        },
        MUIDataTableBodyRow: {
          root: {
            // height: "43px",
            '&:hover': {
              cursor: "pointer"
            }
          },
        },
        MUIDataTableBodyCell: {
          root: {
            textOverflow: "ellipsis",
            textAlign: "left",
            whiteSpace: "nowrap",
            overflow: "hidden"
          }
        },
        MuiTablePagination: {
          caption: {
            color: "#467175",
            fontSize: "0.75rem"
          }
        },
        MUIDataTableHeadCell: {
          root: {
            backgroundColor: "rgb(91, 100, 109)",
            color: "#FFFFFF",
            textAlign: "left",
          },
          fixedHeader: {
            backgroundColor: "rgb(91, 100, 109)",
            color: "#FFFFFF",
            textAlign: "left",
          },
          button: {
            color: "#FFFFFF",
            textAlign: "center"
          },
          sortActive: {
            color: "#FFFFFF"
          },
          toolButton: {
            marginLeft: 0
          },
          contentWrapper: {
            display: "block",
            margin: "0 auto"
          }
        },
        MUIDataTable: {
          paper: {
            height: '100%',
          },
          responsiveScroll: {
            maxHeight: 'none',
            height: 'calc(100% - 128px)'
          },
          tableRoot: {
            tableLayout: "fixed"
          }
        },
        MUIDataTableToolbar: {
          titleRoot: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center"
          }
        }
      }
    });

    //custom dropdown menu behaviour for laudromat filters
    //filterLabel: what the filter is listed as in the menu
    //filterName: the name of the column we are building a dropdown menu for
    //labelFor: optional, the text that will be displayed when you apply a filter (uses raw stored value)
    //getChoiceValue: optional, this fixes the issue where survey cleaners are stored in a different location
    //normalize: optional, this is when an option is an "absense of" a status ("No Status" for Survey Status is an example of this)
    //sort with: optional, by default is alphabetical
    const buildFilterDropdown = ({
      filterLabel,
      filterName,
      labelFor = v => v,
      getChoiceValue = row => row[filterName],
      normalize = v => v,
      sortWith = undefined
    }) => ({
      filter: true,
      filterType: 'custom',
      filterOptions: {
        logic: (value, filters) =>
          filters.length > 0 && !filters.includes(normalize(value)),
        display: (filterList, onChange, index, column) => {
          const choices = [...new Set(
            (store?.surveyListDisplay ?? [])
              .map(getChoiceValue)
              .map(normalize)
              .filter(v => v !== null && v !== undefined)
          )].sort(sortWith);

          return (
            <FormControl style={{ width: '100%' }}>
              <InputLabel>{filterLabel}</InputLabel>
              <Select multiple
                value={filterList[index] || []}
                onChange={event => onChange(event.target.value, index, column)}
                MenuProps={filterMenuPropsDropdown}
                renderValue={selected => selected.map(labelFor).join(', ')}
              >
                {choices.map(choice => (
                  <MenuItem key={choice} value={choice}>
                    {labelFor(choice)}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          );
        }
      }
    });

    const columns = [
      {
        name: "SurveyID",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "",
        options: {
          filter: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            let rowData = tableMeta.currentTableData[tableMeta.rowIndex].data;
            let surveyId = rowData[0];
            return <div style={{ width: "100%", height: "100%", display: "inline-block" }} > <button style={{ width: "fit-content", height: "80%", fontSize: "13px" }} class="btn btn-add-row" onClick={() => { setBlockRowExpansion(true); beam(surveyId); }}><i class="fa fa-lg fa-sign-in-alt fa-nohover2" aria-hidden="true"></i></button></div>
          }
        }
      },
      {
        label: "Plan",
        name: "Plan",
        editable: "never",
        options: {
          filter: false,
        },
        render: rowData => <>{rowData.Plan}</>
      },
      {
        label: "Partnership",
        name: "PlanPartnershipNameShort",
        editable: "never",
        options: buildFilterDropdown({ filterLabel: 'Partnership', filterName: 'PlanPartnershipNameShort' })
      },
      {
        label: "Product",
        name: "Product",
        editable: "never",
        options: buildFilterDropdown({ filterLabel: 'Product', filterName: 'Product' })
      },
      {
        label: "Country",
        name: "CountryName",
        editable: "never",
        options: buildFilterDropdown({ filterLabel: 'Country', filterName: 'CountryName' })
      },
      {
        label: "Questions Sent",
        editable: "never",
        name: "DateQuestionSent",
        options: {
          filter: false,
          customBodyRender: value => {
            if (value) {
              let date = new Date(value);
              return <>{formatAMPM(date)}</>;
            }
          }
        },
      },
      {
        label: "DataYear",
        editable: "never",
        name: "DataYear",
        options: buildFilterDropdown({ filterLabel: 'Data Year', filterName: 'DataYear' })
      },
      {
        label: "Received",
        name: "OriginalDateCompleted",
        editable: "never",
        options: {
          filter: false,
          customBodyRender: value => {
            if (value) {
              let date = new Date(value);
              return <>{formatAMPM(date)}</>;
            }
          }
        },
      },
      {
        label: "Active",
        editable: "never",
        name: "LatestActivity",
        options: {
          filter: false,
          sortDirection: 'asc',
          customBodyRender: value => {
            if (value) {
              let date = new Date(value);
              return <>{formatAMPM(date)}</>;
            }
          }
        },
      },
      {
        label: "Changes",
        name: "NumChanges",
        editable: "never",
        options: {
          filter: false,
        },
      },
      {
        label: "Survey Status",
        name: "SurveyStatusID",
        options: {
          ...buildFilterDropdown({
            filterLabel: 'Survey Status',
            filterName: 'SurveyStatusID',
            labelFor: v => displayMap.SurveyStatusID[v] ?? "No Status",
            normalize: v => displayMap.SurveyStatusID[v] !== undefined ? v : "No Status",
          }),
          customBodyRender: (value, tableMeta) => {
            let rowData = tableMeta.currentTableData[tableMeta.rowIndex].data;
            let surveyId = rowData[0];
            return <StatusDataColumn surveyId={surveyId} />;
          }
        },
      },
      {
        label: "Cleaner",
        name: "SurveyCleanersMixed",
        options: {
          ...buildFilterDropdown({
            filterLabel: 'Cleaner',
            filterName: 'SurveyCleanersMixed',
            getChoiceValue: s => {
              const name = cleanerStr(s.SurveyID);
              return (typeof name === 'string' && name.trim() !== '') ? name : null;
            },
            normalize: v => v || "No Cleaner",
          }),
          customBodyRender: (value, tableMeta) => {
            let rowData = tableMeta.currentTableData[tableMeta.rowIndex].data;
            let surveyId = rowData[0];
            return <CleanerDataColumn value={cleanerStr(surveyId)} surveyId={surveyId} />
          }
        }
      },
      {
        label: "L2 Status",
        name: "IsL2",
        editable: "never",
        options: {
          ...buildFilterDropdown({
            filterLabel: 'L2 Status',
            filterName: 'IsL2',
            labelFor: v => (v ? "True" : "False")
          }),
          customBodyRender: (value, tableMeta) => {
            let rowData = tableMeta.currentTableData[tableMeta.rowIndex].data;
            let surveyId = rowData[0];
            return <L2DataColumn surveyId={surveyId} />
          }
        },
      }
    ];

    const laundroref = useRef(null);
    const [blockRowExpansion, setBlockRowExpansion] = useState(false);
    return (
      <>
        <MuiPickersUtilsProvider utils={MomentUtils} locale={"en"}>
          <MuiThemeProvider theme={muiTheme()}>
            <div id="laundromat-page-table">
              <MaterialTable
                title={
                  <div className="MUIDataTableToolbar-titleRoot-19" aria-hidden="true">
                    <h6 className="MuiTypography-root MUIDataTableToolbar-titleText-20 MuiTypography-h6">Laundromat</h6>
                  </div>
                }
                ref={laundroref}
                options={{
                  draggable: false,
                  pagination: true,
                  rowsPerPage: 100,
                  selectableRows: "single",
                  selectableRowsHeader: false,
                  selectableRowsHideCheckboxes: true,
                  selectToolbarPlacement: "none",
                  filter: true,
                  print: false,
                  download: false,
                  viewColumns: true,
                  fixedHeader: true,
                  tableBodyMaxHeight: "95%",
                  tableBodyHeight: "100%",
                  textLabels: {
                    pagination: {
                      next: "Next Page",
                      previous: "Previous Page",
                      rowsPerPage: "",
                      displayRows: "of",
                    }
                  },
                  expandableRows: true,
                  expandableRowsHeader: false,
                  expandableRowsOnClick: true,
                  isRowExpandable: (dataIndex, expandedRows) => {
                    if (!blockRowExpansion) {
                      return true;
                    }
                    return false;

                  },
                  rowsExpanded: [],
                  renderExpandableRow: (tableRowData, rowMeta) => {
                    const colSpan = tableRowData.length;
                    const surveyId = tableRowData[0];
                    return <LaundromatTableExpandableRow colSpan={colSpan} surveyId={surveyId} />;
                  },
                  onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) => {
                    // Only display one row. If a row is expanded that puts the row count above 1, toggle all rows except the last opened row.

                    if (allExpanded?.length > 1 && curExpanded.length > 0) {
                      for (let rowX of allExpanded) {
                        if (rowX.index != curExpanded[0].index || blockRowExpansion === true) {
                          laundroref.current.toggleExpandRow(rowX);
                        }
                      }
                    }
                  },
                }}
                columns={columns}
                data={store?.surveyListDisplay}
                components={{
                  TableFilterList: CustomFilterList,
                }}
              /></div>
          </MuiThemeProvider>
        </MuiPickersUtilsProvider>
      </>
    )
  })
  return (
    <Container fluid>
      <Row>
        <Col>
          <LaundromatTable />
        </Col>
      </Row>
    </Container>
  );
});

export default LaundromatPage;

//<FormControl>
//    <MuiThemeProvider theme={customFontSize}>
//        <FormControlLabel control={
//            <Checkbox checked={survey.IsLocked} onChange={e => onCheckboxChange(surveyId, "IsLocked", !survey.IsLocked)} />
//        } label="Lock" />
//    </MuiThemeProvider>
//</FormControl>